import React from "react";
import { PrimaryButton } from "extranet-component-library";
import { useTranslation } from "react-i18next";
import walletAlt from "../assets/img/cards/MONEDERO_ALT.svg";
import starAlt from "../assets/img/cards/FAVORITOS_ALT.svg";
import boletoAlt from "../assets/img/cards/boletoAlt.svg";
import out from "../assets/img/LOGOUT_RED.svg";
import claimsAlt from "../assets/img/cards/RECLAMACIONES_ALT.svg";
import alert from "../assets/img/ALARM.svg";
import user from '../assets/img/user.svg';
import { capitalizeMenuString } from "../utils/parsers";
import { MENU } from "../utils/constants";
import { isClaimsVisible, getNotificationsLabel } from "../utils/entities/entityMenuVisibility";

const MobileMenu = ({ props, navigate, collapsed, onLogout }: any) => {
  const { t } = useTranslation();
  const showClaims = isClaimsVisible();

  return (
    <>
      {collapsed ? (
        <div data-testid="menu" className="burger-menu">
          <ul>
            <li onClick={() => navigate(props, MENU.WALLET.URL)}>
              <img src={walletAlt} alt="" />
              <div>{capitalizeMenuString(t(MENU.WALLET.LABEL))}</div>
            </li>
            <li onClick={() => navigate(props, MENU.NEXT_TRAVEL.URL)}>
              <img src={boletoAlt} alt="" />
              <div>{capitalizeMenuString(t(MENU.NEXT_TRAVEL.LABEL))}</div>
            </li>
            <li onClick={() => navigate(props, MENU.FAVORITES.URL)}>
              <img src={starAlt} alt="" />{" "}
              <div>{capitalizeMenuString(t(MENU.FAVORITES.LABEL))}</div>
            </li>
            {showClaims && (
              <li onClick={() => navigate(props, MENU.CLAIMS.URL)}>
                <img src={claimsAlt} alt="" />{" "}
                <div>{capitalizeMenuString(t(MENU.CLAIMS.LABEL))}</div>
              </li>
            )}
            <li onClick={() => navigate(props, MENU.PROFILE.URL)}>
              <img src={user} alt="" />{" "}
              <div>{capitalizeMenuString(t(MENU.PROFILE.LABEL))}</div>
            </li>
            <li onClick={() => navigate(props, MENU.NOTIFICATIONS.URL)}>
              <img src={alert} alt="" />{" "}
              <div>{capitalizeMenuString(t(getNotificationsLabel()))}</div>
            </li>
          </ul>
          <div className="logout">
            <PrimaryButton icon={out} text={t("logout")} onClick={() => onLogout()} />
          </div>
        </div>
      ) : (
        <div data-testid="no-collapsed"></div>
      )}
    </>
  );
};

export default MobileMenu;
